module.exports = __webpack_public_path__ + "static/media/logoFEDE.3e82e707.webp";